/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable no-mixed-spaces-and-tabs */
import React, { useEffect, useMemo } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { reset, submit } from 'redux-form';
import saga from './saga';
import reducer from './reducer';
import {
	getCompaniesTypesAction,
	getCompanyAdminSettingsAction,
	getCompanyInfoAction,
	getCompanySettingsAction,
	getOrgTypesAction,
	getTaxSystemsAction,
	resetStateAction,
	updateCompanyAction,
	updateCompanyAdminSettingsAction,
	updateCompanySettingsAction,
	getCompanyAboutInfoAction,
	createCompanyAboutInfo,
	getCompanyOptionsAction,
	getStagesAction,
	getDocumentsTypesAction,
} from './actions';
import {
	getActiveCompanyIdSelector,
	getCompanyContactsInfoSelector,
	getCompanyTaxSystemInfoSelector,
	getCompaniesTabsSelector,
	getCompanyAdminSettingInfoSelector,
	getIsAboutTabShownSelector,
	getCompanyInfoSelector,
	getCompanyNameSelector,
	getCompanySettingInfoSelector,
	getIsAdminSettingTabShownSelector,
	getIsAuditTabShownSelector,
	getIsCompanyAdminSettingEditFormOpenSelector,
	getIsCompanyAdminSettingLoadingSelector,
	getIsCompanyAdminSettingSavingSelector,
	getIsCompanyEditFormOpenSelector,
	getIsCompanyInfoLoadingSelector,
	getIsCompanySettingEditFormOpenSelector,
	getIsCompanySettingLoadingSelector,
	getIsCompanySettingSavingSelector,
	getIsModalShownSelector,
	getIsProfileCompanyFormSelector,
	getIsSettingTabShownSelector,
	getCompanyInfoAboutSelector,
	getIsCompanyAboutLoadingSelector,
	getIsCompanyAboutEditFormOpenSelector,
	getIsAllCompanyReferenceDataLoadedSelector,
	getIsCompaniesPatchLoadingSelector,
	getStagesSelector,
	getDocumentTypesOptionsSelector,
	getIsStagesLoadingSelector,
	getIsDocumentsTypesLoadingSelector,
} from './selectors';
import { useInjectSaga } from '../../../utils/injectSaga';
import { useInjectReducer } from '../../../utils/injectReducer';
import { CompanyContent } from './components/company-content';
import { ModalWindow } from '../../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../../semantic-ui/components/modal-window/modal-footer-buttons';
import { removeModalQuery } from '../../../utils/removeModalQuery';
import {
	getIsAvailableCompaniesButtonsSelector,
	getIsAvailableMyCompaniesButtonsSelector,
	getUserInfoSelector,
} from '../../profile/selectors';
import { Audit } from '../../../components/audit';
import cancelModal from '../../../utils/cancelModal';
import closeModal from '../../../utils/closeModal';
import CompanySettings from './components/company-settings';
import CompanyAdminSettings from './components/company-admin-settings';
import CompanyAbout from './components/company-about';
import { FORM_NAME, FORM_ABOUT_NAME, FORM_SETTINGS_ADMIN_NAME, FORM_SETTINGS_NAME } from './constants';

const CompaniesModalWrapper = ({
	onGetCompanyInfo,
	isCompanyInfoLoading,
	isCompanyEditFormOpen,
	companyInfo,
	companyName,
	isModalShown,
	activeCompanyId,
	onUpdateCompany,
	onGetCompaniesTypes,
	isAvailableCompany,
	isAuditTabShown,
	isSettingTabShown,
	isProfileCompanyForm,
	companyTaxInfo,
	companyContacts,
	userInfo,
	companiesTabs,
	onGetOrgTypes,
	onGetTaxSystems,
	isAvailableMyCompany,
	isCompanySettingLoading,
	onUpdateCompanySettings,
	onGetCompanySetting,
	companySettingInfo,
	isCompanySettingSaving,
	isCompanySettingEditFormOpen,
	isAdminSettingTabShown,
	onGetCompanyAdminSetting,
	onUpdateAdminCompanySettings,
	companyAdminSettingInfo,
	isCompanyAdminSettingSaving,
	isCompanyAdminSettingLoading,
	isCompanyAdminSettingEditFormOpen,
	isAboutTabShown,
	companyAboutInfo,
	onGetCompanyAboutInfo,
	isCompanyAboutEditFormOpen,
	onGetAboutTypes,
	onCreateCompanyAboutInfo,
	isCompanyAboutInfoLoading,
	getAllCompanyAboutInfoLoading,
	isCompaniesPatchLoading,
	onFormSubmit,
	stages,
	documentTypes,
	isStagesLoading,
	isDocumentsTypesLoading,
	onGetDocumentTypes,
	onGetStages,
	onClearForm,
	onClearFormSettings,
	onClearFormSettingsAdmin,
	onClearFormAbout,
}) => {
	useInjectSaga({ key: 'companiesModalSaga', saga });
	useInjectReducer({ key: 'companiesModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	const tab = query.get('tab');

	const mode = query.get('mode');

	useEffect(() => {
		if (activeCompanyId) onGetCompanyInfo(activeCompanyId);
	}, [activeCompanyId]);

	useEffect(() => {
		if (isCompanyEditFormOpen) {
			onGetCompaniesTypes();
			onGetOrgTypes();
			onGetTaxSystems();
		}

		if (isCompanyAboutEditFormOpen) {
			onGetAboutTypes();
		}
	}, [isCompanyEditFormOpen, isCompanyAboutEditFormOpen]);

	useEffect(() => {
		if (activeCompanyId && isSettingTabShown) {
			onGetCompanySetting(activeCompanyId);
			onGetDocumentTypes(8);
			onGetStages();
		}
		if (activeCompanyId && isAdminSettingTabShown) {
			onGetCompanyAdminSetting(activeCompanyId);
		}

		if (activeCompanyId && isAboutTabShown) {
			onGetCompanyAboutInfo(activeCompanyId);
		}
	}, [activeCompanyId, isSettingTabShown, isAdminSettingTabShown, isAboutTabShown]);

	const handleCompanyFormOpenButtonClick = mode => {
		if (activeCompanyId) {
			query.set('id', activeCompanyId);
		} else {
			query.delete('id');
		}

		if (mode === 'edit') {
			query.set('mode', 'edit');
		}

		if (mode === 'setting-edit') {
			query.set('mode', 'settings-edit');
		}

		if (mode === 'about-company-edit') {
			query.set('mode', 'about-company-edit');
		}

		if (mode === 'settings') {
			query.delete('mode');
			query.set('tab', 'settings');
		}
		if (mode === 'modules-edit') {
			query.set('mode', 'modules-edit');
		}

		if (mode === 'modules') {
			query.delete('mode');
			query.set('tab', 'modules');
		}

		if (mode === 'cancel') {
			query.delete('mode');
			onClearForm();
		}

		if (mode === 'cancel-settings') {
			query.delete('mode');
			query.set('tab', 'settings');
			onClearFormSettings();
		}
		if (mode === 'cancel-modules') {
			query.delete('mode');
			query.set('tab', 'modules');
			onClearFormSettingsAdmin();
		}

		if (mode === 'cancel-about') {
			query.delete('mode');
			query.set('tab', 'about');
			onClearFormAbout();
		}

		if (mode === 'cancel-about-company-info') {
			query.delete('mode');
			query.set('tab', 'about');
			onClearFormAbout();
		}

		if (mode === 'cancel' && !activeCompanyId) {
			query.delete('modal');
			onClearForm();
		}

		history.push(`${pathname}?${query}`);
	};

	const handleModalCancel = () => {
		cancelModal(query);
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		history.push(`${pathname}?${query}`);
	};

	const handleCompanyFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);
		if (activeCompanyId) {
			onUpdateCompany({
				id: activeCompanyId,
				redirect: () => handleCompanyFormOpenButtonClick('cancel'),
				searchQuery: removeModalQuery(query.toString()),
			});
		}
	};

	const handleCompanySettingFormSubmit = async () => {
		await onFormSubmit(FORM_SETTINGS_NAME);
		if (activeCompanyId) {
			onUpdateCompanySettings({
				id: activeCompanyId,
				redirect: () => handleCompanyFormOpenButtonClick('cancel-settings'),
				searchQuery: removeModalQuery(query.toString()),
			});
		}
	};

	const handleCompanyAdminSettingFormSubmit = () => {
		if (activeCompanyId) {
			onUpdateAdminCompanySettings({
				id: activeCompanyId,
				redirect: () => handleCompanyFormOpenButtonClick('cancel-modules'),
				searchQuery: removeModalQuery(query.toString()),
			});
		}
	};

	const handleCompanyAboutFormSubmit = async () => {
		await onFormSubmit(FORM_ABOUT_NAME);
		if (activeCompanyId) {
			onCreateCompanyAboutInfo({
				id: activeCompanyId,
				redirect: () => handleCompanyFormOpenButtonClick('cancel-about-company-info'),
			});
		}
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleCompanyFormSubmit();
		}
	};

	const handleNavItemClick = tab => {
		if (tab === 'info') {
			query.delete('tab');
		}

		if (tab === 'about') {
			query.set('tab', 'about');
		}

		if (tab === 'audit') {
			query.set('tab', 'audit');
		}
		if (tab === 'settings') {
			query.set('tab', 'settings');
		}
		if (tab === 'modules') {
			query.set('tab', 'modules');
		}
		history.push(`${pathname}?${query}`);
	};

	const tabs = useMemo(() => {
		const tabs = [
			{
				id: 'info',
				text: 'Информация',
				onClick: () => handleNavItemClick('info'),
				isActive: !tab && !mode,
			},
		];

		if (companiesTabs.about) {
			tabs.push({
				id: 'about',
				text: 'О компании',
				onClick: () => handleNavItemClick('about'),
				isActive: tab === 'about' && !mode,
			});
		}

		if (companiesTabs.audit) {
			tabs.push({
				id: 'audit',
				text: 'Изменения',
				onClick: () => handleNavItemClick('audit'),
				isActive: tab === 'audit' && !mode,
			});
		}

		if (companiesTabs.settings) {
			tabs.push({
				id: 'settings',
				text: 'Настройки',
				onClick: () => handleNavItemClick('settings'),
				isActive: (tab === 'settings' && !mode) || (tab === 'settings' && mode === 'settings-edit'),
			});
		}
		if (companiesTabs.modules) {
			tabs.push({
				id: 'modules',
				text: 'Настройки (Админ)',
				onClick: () => handleNavItemClick('modules'),
				isActive: (tab === 'modules' && !mode) || (tab === 'modules' && mode === 'modules-edit'),
			});
		}

		return tabs;
	}, [companiesTabs, tab, mode]);

	const activeEditButton = userInfo.find(el => el.id === 'company')?.value?.id === Number(activeCompanyId);

	const modalContent = useMemo(() => {
		if (!isAuditTabShown && !isSettingTabShown && !isAdminSettingTabShown && !isAboutTabShown) {
			return (
				<CompanyContent
					companyInfo={companyInfo}
					isCompanyInfoLoading={isCompanyInfoLoading}
					isCompanyFormOpen={isCompanyEditFormOpen}
					companyTaxInfo={companyTaxInfo}
					companyContacts={companyContacts}
				/>
			);
		}
		if (isAboutTabShown && !isSettingTabShown && !isAuditTabShown && !isAdminSettingTabShown) {
			return <CompanyAbout companyAboutInfo={companyAboutInfo} />;
		}

		if (isSettingTabShown && !isAuditTabShown && !isAdminSettingTabShown && !isAboutTabShown) {
			return (
				<CompanySettings
					activeCompanyId={activeCompanyId}
					companySettingInfo={companySettingInfo}
					stages={stages}
					documentTypes={documentTypes}
					isDocumentsTypesLoading={isDocumentsTypesLoading}
					isStagesLoading={isStagesLoading}
				/>
			);
		}

		if (isAuditTabShown && !isSettingTabShown && !isAdminSettingTabShown && !isAboutTabShown) {
			return <Audit entityName="companies" entityId={activeCompanyId} />;
		}
		if (!isAuditTabShown && !isSettingTabShown && isAdminSettingTabShown && !isAboutTabShown) {
			return (
				<CompanyAdminSettings
					activeCompanyId={activeCompanyId}
					companyAdminSettingInfo={companyAdminSettingInfo}
				/>
			);
		}

		return null;
	}, [
		isAuditTabShown,
		isSettingTabShown,
		companyInfo,
		isCompanyInfoLoading,
		isCompanyEditFormOpen,
		companyTaxInfo,
		companyContacts,
		activeCompanyId,
		isAdminSettingTabShown,
		companyAboutInfo,
		isAboutTabShown,
	]);

	const rightButtons = useMemo(() => {
		if (
			isCompanyEditFormOpen &&
			!isAuditTabShown &&
			!isSettingTabShown &&
			!isAdminSettingTabShown &&
			!isAboutTabShown
		) {
			return [
				{
					onClick: handleCompanyFormSubmit,
					text: 'Сохранить',
					color: 'primary',
					loading: isCompanyInfoLoading,
					disabled: isCompanyInfoLoading,
				},
				{
					onClick: () => handleCompanyFormOpenButtonClick('cancel'),
					text: 'Отмена',
					color: 'secondary',
					disabled: isCompanyInfoLoading,
				},
			];
		}

		const canShowAboutInfoSaveButton = isCompanyAboutEditFormOpen && mode === 'about-company-edit';
		if (canShowAboutInfoSaveButton) {
			return [
				{
					onClick: handleCompanyAboutFormSubmit,
					text: 'Сохранить',
					color: 'primary',
					loading: isCompaniesPatchLoading,
					disabled: getAllCompanyAboutInfoLoading || isCompaniesPatchLoading,
				},
				{
					onClick: () => handleCompanyFormOpenButtonClick('cancel-about-company-info'),
					text: 'Отмена',
					color: 'secondary',
					disabled: isCompaniesPatchLoading,
				},
			];
		}

		const canShowAboutSaveButton = isAboutTabShown && mode === 'settings-about';

		if (canShowAboutSaveButton) {
			return [
				{
					onClick: handleCompanyAboutFormSubmit,
					text: 'Сохранить',
					color: 'primary',
					loading: isCompanySettingSaving,
					disabled: isCompanySettingSaving,
				},
				{
					onClick: () => handleCompanyFormOpenButtonClick('cancel-about'),
					text: 'Отмена',
					color: 'secondary',
					disabled: isCompanySettingSaving,
				},
			];
		}

		const canShowSettingsSaveButton = isSettingTabShown && mode === 'settings-edit';

		if (canShowSettingsSaveButton) {
			return [
				{
					onClick: handleCompanySettingFormSubmit,
					text: 'Сохранить',
					color: 'primary',
					loading: isCompanySettingSaving,
					disabled: isCompanySettingSaving || isStagesLoading || isDocumentsTypesLoading,
				},
				{
					onClick: () => handleCompanyFormOpenButtonClick('cancel-settings'),
					text: 'Отмена',
					color: 'secondary',
					disabled: isCompanySettingSaving,
				},
			];
		}

		const canShowAdminSettingsSaveButton = isAdminSettingTabShown && mode === 'modules-edit';
		if (canShowAdminSettingsSaveButton) {
			return [
				{
					onClick: handleCompanyAdminSettingFormSubmit,
					text: 'Сохранить',
					color: 'primary',
					loading: isCompanyAdminSettingSaving,
					disabled: isCompanyAdminSettingSaving,
				},
				{
					onClick: () => handleCompanyFormOpenButtonClick('cancel-modules'),
					text: 'Отмена',
					color: 'secondary',
					disabled: isCompanyAdminSettingSaving,
				},
			];
		}

		const buttons = [];

		const canShowEditButton =
			!isCompanyInfoLoading &&
			((isAvailableCompany.update && !isProfileCompanyForm) ||
				(isAvailableMyCompany.update && isProfileCompanyForm && activeEditButton)) &&
			!isAuditTabShown &&
			!isSettingTabShown &&
			!isAdminSettingTabShown &&
			!isAboutTabShown;

		if (canShowEditButton) {
			buttons.push({
				onClick: () => handleCompanyFormOpenButtonClick('edit'),
				text: 'Изменить',
				color: 'primary',
				disabled: isCompanyInfoLoading,
			});
		}

		const canShowSettingsEditButton =
			isAvailableMyCompany.update &&
			isProfileCompanyForm &&
			activeEditButton &&
			!isAuditTabShown &&
			!isAdminSettingTabShown &&
			!isAboutTabShown &&
			isSettingTabShown &&
			mode !== 'settings-edit';

		if (canShowSettingsEditButton) {
			buttons.push({
				onClick: () => handleCompanyFormOpenButtonClick('setting-edit'),
				text: 'Изменить',
				color: 'primary',
				disabled: isCompanySettingLoading,
			});
		}

		const canShowAboutEditButton =
			isAvailableMyCompany.update &&
			isProfileCompanyForm &&
			activeEditButton &&
			!isAuditTabShown &&
			!isAdminSettingTabShown &&
			!isSettingTabShown &&
			isAboutTabShown &&
			mode !== 'about-company-edit';

		if (canShowAboutEditButton) {
			buttons.push({
				onClick: () => handleCompanyFormOpenButtonClick('about-company-edit'),
				text: 'Изменить',
				color: 'primary',
				disabled: isCompanyAboutInfoLoading,
			});
		}

		const canShowAdminSettingsEditButton =
			isAvailableCompany.update &&
			!isProfileCompanyForm &&
			!isAuditTabShown &&
			!isSettingTabShown &&
			!isAboutTabShown &&
			isAdminSettingTabShown &&
			mode !== 'modules-edit';

		if (canShowAdminSettingsEditButton) {
			buttons.push({
				onClick: () => handleCompanyFormOpenButtonClick('modules-edit'),
				text: 'Изменить',
				color: 'primary',
				disabled: isCompanyAdminSettingLoading,
			});
		}

		buttons.push({
			onClick: handleModalCancel,
			text: 'Закрыть',
			color: 'secondary',
		});

		return buttons;
	}, [
		isCompanyEditFormOpen,
		isAuditTabShown,
		isSettingTabShown,
		isCompanyInfoLoading,
		isAvailableCompany.update,
		isAvailableMyCompany.update,
		isProfileCompanyForm,
		isAboutTabShown,
		activeEditButton,
		handleCompanyFormSubmit,
		handleCompanyFormOpenButtonClick,
		handleModalCancel,
		mode,
		isAdminSettingTabShown,
		isCompanyAdminSettingLoading,
	]);

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText={
				isCompanyEditFormOpen
					? 'Изменить компанию'
					: isCompanySettingEditFormOpen
					? 'Изменить настройки'
					: isCompanyAdminSettingEditFormOpen
					? 'Изменить настройки (Админ)'
					: isCompanyAboutEditFormOpen
					? 'Изменить открытую информацию о компании  '
					: isAboutTabShown && companyInfo[1]?.value
					? `${companyName}, ${companyInfo[1].value}`
					: companyName
			}
			navItems={
				isCompanyEditFormOpen ||
				isCompanySettingEditFormOpen ||
				isCompanyAdminSettingEditFormOpen ||
				isCompanyAboutEditFormOpen
					? []
					: tabs
			}
			modalContent={modalContent}
			style={{ width: '895px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'company-modal' }]}
			footerButtons={<ModalFooterButtons rightButtons={rightButtons} />}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isCompanyAboutInfoLoading: getIsCompanyAboutLoadingSelector(),
	getAllCompanyAboutInfoLoading: getIsAllCompanyReferenceDataLoadedSelector(),
	companySettingInfo: getCompanySettingInfoSelector(),
	companyInfo: getCompanyInfoSelector(),
	isCompanyInfoLoading: getIsCompanyInfoLoadingSelector(),
	isCompanyEditFormOpen: getIsCompanyEditFormOpenSelector(),
	isCompanyAboutEditFormOpen: getIsCompanyAboutEditFormOpenSelector(),
	companyName: getCompanyNameSelector(),
	isModalShown: getIsModalShownSelector(),
	activeCompanyId: getActiveCompanyIdSelector(),
	isCompaniesPatchLoading: getIsCompaniesPatchLoadingSelector(),
	isAvailableCompany: getIsAvailableCompaniesButtonsSelector(),
	isAvailableMyCompany: getIsAvailableMyCompaniesButtonsSelector(),
	isAuditTabShown: getIsAuditTabShownSelector(),
	isSettingTabShown: getIsSettingTabShownSelector(),
	isAboutTabShown: getIsAboutTabShownSelector(),
	isProfileCompanyForm: getIsProfileCompanyFormSelector(),
	companiesTabs: getCompaniesTabsSelector(),
	companyTaxInfo: getCompanyTaxSystemInfoSelector(),
	companyContacts: getCompanyContactsInfoSelector(),
	companyAboutInfo: getCompanyInfoAboutSelector(),
	userInfo: getUserInfoSelector(),
	isCompanySettingLoading: getIsCompanySettingLoadingSelector(),
	isCompanySettingSaving: getIsCompanySettingSavingSelector(),
	isCompanyAdminSettingLoading: getIsCompanyAdminSettingLoadingSelector(),
	isCompanyAdminSettingSaving: getIsCompanyAdminSettingSavingSelector(),
	isCompanySettingEditFormOpen: getIsCompanySettingEditFormOpenSelector(),
	isAdminSettingTabShown: getIsAdminSettingTabShownSelector(),
	companyAdminSettingInfo: getCompanyAdminSettingInfoSelector(),
	isCompanyAdminSettingEditFormOpen: getIsCompanyAdminSettingEditFormOpenSelector(),
	stages: getStagesSelector(),
	documentTypes: getDocumentTypesOptionsSelector(),
	isStagesLoading: getIsStagesLoadingSelector(),
	isDocumentsTypesLoading: getIsDocumentsTypesLoadingSelector(),
});

const mapDispatchToProps = {
	onGetCompanyInfo: getCompanyInfoAction,
	onResetState: resetStateAction,
	onUpdateCompany: updateCompanyAction,
	onUpdateCompanySettings: updateCompanySettingsAction,
	onGetCompaniesTypes: getCompaniesTypesAction,
	onGetOrgTypes: getOrgTypesAction,
	onGetAboutTypes: getCompanyOptionsAction,
	onGetTaxSystems: getTaxSystemsAction,
	onGetCompanySetting: getCompanySettingsAction,
	onGetCompanyAdminSetting: getCompanyAdminSettingsAction,
	onGetCompanyAboutInfo: getCompanyAboutInfoAction,
	onFormSubmit: submit,
	onUpdateAdminCompanySettings: updateCompanyAdminSettingsAction,
	onCreateCompanyAboutInfo: createCompanyAboutInfo,
	onGetStages: getStagesAction,
	onGetDocumentTypes: group => getDocumentsTypesAction({ group }),
	onClearForm: () => reset(FORM_NAME),
	onClearFormSettings: () => reset(FORM_SETTINGS_NAME),
	onClearFormSettingsAdmin: () => reset(FORM_SETTINGS_ADMIN_NAME),
	onClearFormAbout: () => reset(FORM_ABOUT_NAME),
};

const CompaniesModal = connect(mapStateToProps, mapDispatchToProps)(CompaniesModalWrapper);

CompaniesModalWrapper.propTypes = {
	onGetCompanyInfo: PropTypes.func.isRequired,
	onGetOrgTypes: PropTypes.func.isRequired,
	onGetAboutTypes: PropTypes.func.isRequired,
	onGetTaxSystems: PropTypes.func.isRequired,
	companyInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	companyAboutInfo: PropTypes.array,
	companyTaxInfo: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	companyContacts: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string.isRequired,
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
		}),
	),
	isCompanyInfoLoading: PropTypes.bool.isRequired,
	getAllCompanyAboutInfoLoading: PropTypes.bool.isRequired,
	isCompaniesPatchLoading: PropTypes.bool.isRequired,
	isCompanyAboutInfoLoading: PropTypes.bool.isRequired,
	onFormSubmit: PropTypes.func.isRequired,
	isCompanyEditFormOpen: PropTypes.bool.isRequired,
	isCompanyAboutEditFormOpen: PropTypes.bool.isRequired,
	companyName: PropTypes.string.isRequired,
	onResetState: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	activeCompanyId: PropTypes.string,
	onUpdateCompany: PropTypes.func.isRequired,
	onUpdateCompanySettings: PropTypes.func.isRequired,
	onGetCompaniesTypes: PropTypes.func.isRequired,
	isAvailableCompany: PropTypes.objectOf(PropTypes.bool),
	isAvailableMyCompany: PropTypes.objectOf(PropTypes.bool),
	isAuditTabShown: PropTypes.bool.isRequired,
	isAdminSettingTabShown: PropTypes.bool.isRequired,
	isSettingTabShown: PropTypes.bool.isRequired,
	isAboutTabShown: PropTypes.bool.isRequired,
	isProfileCompanyForm: PropTypes.bool.isRequired,
	isCompanySettingLoading: PropTypes.bool.isRequired,
	companiesTabs: PropTypes.shape({
		audit: PropTypes.bool,
		about: PropTypes.bool,
		settings: PropTypes.bool,
		modules: PropTypes.bool,
	}).isRequired,
	userInfo: PropTypes.array.isRequired,
	onGetCompanySetting: PropTypes.func.isRequired,
	onGetCompanyAdminSetting: PropTypes.func.isRequired,
	onGetCompanyAboutInfo: PropTypes.func.isRequired,
	onUpdateAdminCompanySettings: PropTypes.func.isRequired,
	onCreateCompanyAboutInfo: PropTypes.func.isRequired,
	companySettingInfo: PropTypes.object,
	companyAdminSettingInfo: PropTypes.object,
	isCompanySettingSaving: PropTypes.bool.isRequired,
	isCompanyAdminSettingSaving: PropTypes.bool.isRequired,
	isCompanySettingEditFormOpen: PropTypes.bool.isRequired,
	isCompanyAdminSettingLoading: PropTypes.bool.isRequired,
	isCompanyAdminSettingEditFormOpen: PropTypes.bool.isRequired,
	stages: PropTypes.array,
	documentTypes: PropTypes.array,
	isDocumentsTypesLoading: PropTypes.bool.isRequired,
	onGetStages: PropTypes.func.isRequired,
	onGetDocumentTypes: PropTypes.func.isRequired,
	isStagesLoading: PropTypes.bool.isRequired,
	onClearForm: PropTypes.func.isRequired,
	onClearFormSettings: PropTypes.func.isRequired,
	onClearFormSettingsAdmin: PropTypes.func.isRequired,
	onClearFormAbout: PropTypes.func.isRequired,
};

export default CompaniesModal;
